import { EMPTY_OBJECT } from '../../../constants/common'
import { DraftCreateActionSelect } from '../../Draft'
import { EmailCreateButton } from '../EmailCreateButton'

function EmailDraftCreateActionSelect({
  controlProps = EMPTY_OBJECT,
  ...props
}) {
  return (
    <DraftCreateActionSelect
      {...props}
      controlProps={{ Button: EmailCreateButton, ...controlProps }}
      createNewLabelKey='Email.CreateNewKey'
      openDraftLabelKey='Email.OpenDraftKey'
    />
  )
}

export default EmailDraftCreateActionSelect
